<template>
    <div class="container">
        <swiper
            :loop="true"
            :autoplay="{
               delay: 0,
               stopOnLastSlide: false,
               disableOnInteraction: false
            }"
            :speed="5000"
            :free-mode="true"
            :effect="'coverflow'"
            :slidesPerView="'auto'"
            :coverflowEffect="{
        rotate: 30,
        stretch: -20,
        depth: 150,
        modifier: 0.8,
        slideShadows: true,
      }"
            :pagination="true"
            :modules="modules"
            class="mySwiper"
        >
            <swiper-slide v-for="(slide, index) in slides" :key="index">
                <div class="slide-content">
                    <img v-if="slide.img" :src="slide.img" />
                    <div class="text-content">
                        <h3>{{ slide.title }}</h3>
                        <p class="swiper-description">{{ slide.description }}</p >
                    </div>
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script setup lang="ts">
import { ref} from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { EffectCoverflow, Pagination, Autoplay, FreeMode} from 'swiper/modules';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
// 导入样式
import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import 'swiper/css/free-mode'
const modules = [EffectCoverflow, Pagination, Autoplay, FreeMode]

interface Slide {
    title: string
    description: string
    img: string
    link?: string
}

const slides = ref<Slide[]>([
    {
        title: '2UT',
        img:require('@/assets/img/RWA/2UT.png'),
        link:'https://www.brighsun.com/projects.html',
        description: t('2015 年，Brighsun 获得了吉尼斯世界纪录，成为澳大利亚墨尔本电动公交车单次充电（非太阳能）行驶里程最长的公交车，行驶里程达 1,018 公里。Brighsun 开发了专有的锂硫电池，并转向固态钠离子电池和自己的电动汽车 (EV) 的开发。后者在成本、易燃性、不稳定反应物、寿命和强度方面比锂离子电池具有显著优势。2023 年，Brighsun 实现了 18650 电池的量产，这将为其即将推出的电动汽车提供卓越的安全性和 800-1000 公里的单次充电续航里程。')
    },
    {
        title: 'DIGAU',
        img:require('@/assets/img/RWA/DIGAU.png'),
        link:'https://dignitygold.com/',
        description: t('DIGau 在美国内华达州的尾矿和冲积矿床中拥有超过 60 亿美元的黄金储量，并在经过核实的 NI 43-101 报告中进行了评估。截至 2021 年 3 月 26 日，未开采的黄金储量为 3,442,144 盎司，计划于今年晚些时候开始开采。今年，Dignity 正在将该资产再增加 300 万盎司。DIGau 数字股票提供了进入潜在高利润采矿领域的机会，其内在价值隐含提供了更安全、更稳定的投资，同时提供了比仅与一种资产挂钩的数字股票更多样化的价值和回报。')
    },
    {
        title: 'TS1',
        img:require('@/assets/img/RWA/TS1.jpg'),
        link:'https://en.taishanlpfhk.com/',
        description: t('泰山古陶瓷投资基金由一流的专业古董商、投资者和收藏家团队管理。每件藏品都经过拉曼光谱鉴定，由国际领先的保险公司承保，并存放在具有完整交易历史和所有权记录的专门设施中。该基金旨在为投资者提供 15%-20%+的复合年回报率，初始数字资产基金规模为 1 亿港元。')
    },
    {
        title: 'RXT Greensnow',
        img:require('@/assets/img/RWA/RXT-Greensnow.jpg'),
        link:'暂无',
        description: t('Greensnow Technology Sdn. Bhd. (GTSB) 是马来西亚一家具有环保意识的矿产勘探和开采公司。他们是马来西亚五家获得稀土元素开采许可的公司之一。稀土元素（REEs）是一种化学元素，具有独特的性质，被广泛应用于科技、绿色能源、国防和医疗保健领域。它们是智能手机、计算机、风力涡轮机和医疗成像设备等设备的重要组成部分。GTSB 利用先进的技术和设备勘探锡、金和镍等稀土元素。GTSB 与 Agensi Nuklear Malaysia (ANM) 合作，重点开展与稀土元素（REE）开采相关的试点研发活动。GTSB 的目标是通过其 $REE 数字资产筹集 2 亿美元资金，用于扩大其生态友好型采矿项目。')
    },
    {
        title: 'XLabs',
        img:require('@/assets/img/RWA/XLabs.png'),
        link:'暂无',
        description: t('现实主义、印象主义、表现主义、超现实主义、抽象主义、立体主义. ......是 19 和 20 世纪的主要艺术运动。我们的客户将把一位最伟大画家的画作带到 GreenX 进行数字资产化和上市。请继续关注，因为这仅仅是一个开始，让我们的散户投资者能够投资于非常高价值的现实世界资产，否则，除了超级富有的收藏家之外，这些资产是无法获得的！')
    },
    {
        title: 'ASPAC Capital',
        img:require('@/assets/img/RWA/aspac-cropped-cover.gif'),
        link:'暂无',
        description: t('ASPAC 资本集团由从农场到畜牧业的多家纵向一体化公司组成，横跨新西兰的主要乳制品产区，包括乳制品加工厂。我们提供的是一种新的鲜奶生产和销售模式。作为对这一结构的补充，我们开发并推出了浓缩冷冻牛奶。该产品保留了鲜奶的所有特性，就像在市场上就地取材一样。这已被公认为是一种突破性产品，加强了市场对新西兰鲜奶的无限需求。')
    },
    {
        title: 'Korea Premium Serviced Residence',
        img:require('@/assets/img/RWA/inscape-cover.gif'),
        link:'暂无',
        description: t('韩国江原道中根海滨高级服务公寓的数字资产化。束草和艳阳地区是顶级度假胜地，可提供游泳、冲浪、游艇、海滨徒步旅行等愉悦体验。韩国高级服务公寓由经验丰富的韩国开发商和成功的酒店运营商及总承包商团队共同开发，具有较高的投资价值和稳定的经营收入。')
    },
    {
        title: 'WENEW',
        img:require('@/assets/img/RWA/wenew-animated-cover.gif'),
        link:'暂无',
        description: t('WENEW 与 First Bullion 合作，在 GreenX 数字股票/资产交易平台（GreenX Digital Asset Exchange）首次发行数字股票，并以其在亚洲（包括香港、泰国、新加坡和马来西亚）丰富的活动策划和营销经验为后盾。他们创新性地使用数字资产网络技术和智能票务，旨在彻底改变数字资产和活动票务，为组织者提供开源功能，并连接实体和数字领域。WENEW 的智能门票系统提供防篡改和实时验证功能，首席执行官 Johnny 强调了该系统在元宇宙各个领域的通用性。')
    }
])
</script>

<style scoped lang="scss">
.swiper-description {
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
        overflow: auto;
        white-space: normal;
    }
}
.container {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
}

.swiper {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
}

.swiper-slide {
    background-position: center;
    background-size: cover;
    width: 300px;
    height: 500px;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 15px 50px rgba(0,0,0,0.1);
    overflow: hidden;
}

.slide-content {
    position: relative;
    width: 100%;
    height: 100%;
    perspective: 1000px;
}
.swiper-slide:hover {
    transform: scale(1.5);
}
.slide-content img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.text-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 20px;
    background: rgba(0,0,0,0.7);
    color: white;
    transform: translateZ(30px);
}

.swiper-slide-active .text-content {
    background: rgba(0,0,0,0.9);
}
h3 {
    font-size: 22px;
    font-weight: 500;
}
</style>
<style>
.swiper-free-mode .swiper-wrapper {
    transition-timing-function: linear;
}
</style>